export default function getSuperAdminSiteStatusReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_SUPER_ADMIN_SITE_STATUS_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_SUPER_ADMIN_SITE_STATUS_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_SUPER_ADMIN_SITE_STATUS_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}